/* The enlarged view for the "what's inside" spreads.

   One source, two builds: build.py inlines this into the standalone page and
   mkcss.py copies it to theme/assets/swaha-lightbox.js. The hooks are data
   attributes, not classes, because the theme stylesheet renames every class. */
(function () {
  function init() {
    var root = document.querySelector('[data-swaha-lb]');
    var items = [].slice.call(document.querySelectorAll('[data-swaha-zoom]'));
    if (!root || root.dataset.ready === '1') return;
    if (!items.length) { root.parentNode && root.parentNode.removeChild(root); return; }
    root.dataset.ready = '1';

    var img   = root.querySelector('[data-swaha-lb-img]');
    var stage = root.querySelector('[data-swaha-lb-stage]');
    var title = root.querySelector('[data-swaha-lb-title]');
    var cap   = root.querySelector('[data-swaha-lb-caption]');
    var count = root.querySelector('[data-swaha-lb-count]');
    var close = root.querySelector('[data-swaha-lb-close]');
    var prev  = root.querySelector('[data-swaha-lb-prev]');
    var next  = root.querySelector('[data-swaha-lb-next]');
    var at = 0, zoomed = false;

    if (items.length < 2) { prev.hidden = true; next.hidden = true; count.hidden = true; }

    function unzoom() {
      zoomed = false;
      img.removeAttribute('data-z');
      img.style.transformOrigin = '50% 50%';
    }

    function show(n) {
      at = (n + items.length) % items.length;
      var b = items[at], src = b.querySelector('img');
      unzoom();
      img.src = b.getAttribute('data-full') || (src && (src.currentSrc || src.src)) || '';
      img.alt = (src && src.alt) || '';
      title.textContent = b.getAttribute('data-title') || '';
      cap.textContent = b.getAttribute('data-caption') || '';
      count.textContent = (at + 1) + ' / ' + items.length;
    }

    function open(n) {
      show(n);
      root.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      close.focus();
    }

    function shut() {
      root.hidden = true;
      document.documentElement.style.overflow = '';
      unzoom();
      items[at].focus();          /* back to the spread you were looking at */
    }

    /* Panning: the origin follows the pointer, so a zoomed spread can be read
       corner to corner without dragging. */
    function track(e) {
      if (!zoomed) return;
      var p = e.touches ? e.touches[0] : e, r = img.getBoundingClientRect();
      var x = Math.max(0, Math.min(100, (p.clientX - r.left) / r.width * 100));
      var y = Math.max(0, Math.min(100, (p.clientY - r.top) / r.height * 100));
      img.style.transformOrigin = x + '% ' + y + '%';
    }

    items.forEach(function (b, n) {
      b.addEventListener('click', function () { open(n); });
    });
    close.addEventListener('click', shut);
    prev.addEventListener('click', function () { show(at - 1); });
    next.addEventListener('click', function () { show(at + 1); });
    root.addEventListener('click', function (e) {
      if (e.target === root || e.target === stage) shut();
    });

    img.addEventListener('click', function (e) {
      zoomed = !zoomed;
      img.toggleAttribute('data-z', zoomed);
      if (zoomed) track(e); else unzoom();
    });
    img.addEventListener('mousemove', track);
    img.addEventListener('touchmove', function (e) {
      if (zoomed) { e.preventDefault(); track(e); }
    }, { passive: false });

    document.addEventListener('keydown', function (e) {
      if (root.hidden) return;
      if (e.key === 'Escape') { shut(); return; }
      if (e.key === 'ArrowLeft' && !prev.hidden) { show(at - 1); return; }
      if (e.key === 'ArrowRight' && !next.hidden) { show(at + 1); return; }
      if (e.key !== 'Tab') return;
      var f = [].slice.call(root.querySelectorAll('button')).filter(function (b) { return !b.hidden; });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* the theme editor re-renders the section on every edit */
  document.addEventListener('shopify:section:load', init);
})();
